import { createActionGroup, props } from '@ngrx/store';
import { Order, CreateOrderDto, CreateEncryptedOrderDto, ReopenOrderDto, OrderStatus, OrderComplaint } from '../../models/order.model';

export const OrderActions = createActionGroup({
  source: 'Order',
  events: {
    'Load Orders': props<{ status?: OrderStatus; partnerId?: number; areaId?: number }>(),
    'Load Orders Success': props<{ orders: Order[] }>(),
    'Load Orders Failure': props<{ error: string }>(),
    'Load Order': props<{ id: number }>(),
    'Load Order Success': props<{ order: Order }>(),
    'Create Order': props<{ dto: CreateOrderDto }>(),
    'Create Order Encrypted': props<{ dto: CreateEncryptedOrderDto }>(),
    'Create Order Success': props<{ order: Order }>(),
    'Update Order': props<{ id: number; dto: any }>(),
    'Update Order Success': props<{ order: Order }>(),
    'Reopen Order': props<{ id: number; dto: ReopenOrderDto }>(),
    'Reopen Order Success': props<{ order: Order }>(),
    'Add Complaint': props<{ orderId: number; dto: { complaintTypeId: number; deviceId?: number; description?: string } }>(),
    'Add Complaint Success': props<{ orderId: number; complaint: OrderComplaint }>(),
    'Resolve Complaint': props<{ orderId: number; complaintId: number }>(),
    'Resolve Complaint Success': props<{ orderId: number; complaint: OrderComplaint }>(),
    'Mark Complaint Wont Do': props<{ orderId: number; complaintId: number; reason?: string }>(),
    'Mark Complaint Wont Do Success': props<{ orderId: number; complaint: OrderComplaint }>(),
    'Close Order': props<{ id: number }>(),
    'Close Order Success': props<{ order: Order }>(),
    'Delete Order': props<{ id: number }>(),
    'Delete Order Success': props<{ id: number }>(),
    'Order Failure': props<{ error: string }>(),
  }
});
